import './app.scss';
import { loadDone, progress } from './preload';

import { initLazyLoading } from './js/lazyloading';
import { initShareButtons } from './js/share';
import { QuizMain } from './js/QuizMain';


initLazyLoading();
initShareButtons();

window.addEventListener('load', async () => {
    const quiz = new QuizMain();

    await quiz.start(progress);

    progress(1);

    loadDone();
});
